import { createContext, useContext } from 'react';
import { GetActionMap } from 'api/actions/actions';
import { AxiosRequestConfig } from 'axios';

/**
 * The session context interface.
 */
export interface IApiContext {
  /**
   * The JWT token.
   */
  jwt: string;

  /**
   * The building ID for filtering data by building.
   */
  buildingId: number | null;

  /**
   * The logo URL for the current building.
   */
  logoUrl: string | null;

  /**
   * The name of the current building.
   */
  buildingName: string | null;

  /**
   * Applies branding returned by a public booking-space endpoint.
   */
  setPublicBranding: (branding: { buildingId: number; logoUrl: string | null; buildingName: string | null }) => void;

  /**
   * Returns the action with the given operationId.
   */
  getAction: GetActionMap;

  /** Executes an API request for booking-specific endpoints not in the generated client yet. */
  request: <T = any>(config: AxiosRequestConfig) => Promise<T>;

  /**
   * Clears the local authenticated session.
   */
  destroySession: () => void;
}

/**
 * The session context is used to store the current session.
 *
 * The session context will be provided in <App>.
 */
export const ApiContext = createContext<IApiContext>(undefined!);

/**
 * The use API hook.
 */
export function useApi() {
  return useContext(ApiContext);
}
